import type { Table as ReactTable } from '@tanstack/react-table';
import {
  getTableColumnFixedSizingStyle,
  getTableColumnWidth,
} from '../../utils';

interface DataTableColGroupProps<T> {
  table: ReactTable<T>;
  withFixedColumnWidth?: boolean;
}

export const DataTableColGroup = <T,>({
  table,
  withFixedColumnWidth = false,
}: DataTableColGroupProps<T>) => (
  <colgroup>
    {table.getVisibleLeafColumns().map(column => (
      <col
        key={column.id}
        style={
          withFixedColumnWidth
            ? getTableColumnFixedSizingStyle(column.id)
            : { width: getTableColumnWidth(column.id) }
        }
      />
    ))}
  </colgroup>
);
